import React, { useEffect, useState } from "react";
import { Container, Button, Modal, Spinner } from "react-bootstrap";
import { FaFilePdf, FaEye, FaDownload } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { collection, getDocs } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";

const DownloadDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const collectionRef = collection(db, "sacco", "TEKiK01inpRB3NFlK65S", "documents");

  useEffect(() => {
    fetchDocuments();
  }, []);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const snapshot = await getDocs(collectionRef);
      const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setDocuments(data);
    } catch (err) {
      console.error("Error fetching documents:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePreview = (url) => {
    setPreviewUrl(url);
    setShowModal(true);
  };

  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center text-dark mb-4">Download Documents</h2>
        <p className="text-center text-muted">
          Click <b>Preview</b> to read the file, or <b>Download</b> to save it.
        </p>

        {loading ? (
          <div className="d-flex justify-content-center my-5">
            <Spinner animation="border" />
          </div>
        ) : documents.length === 0 ? (
          <p className="text-center text-muted mt-4">No documents available.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className="p-6 bg-white rounded-lg shadow-lg text-center"
              >
                <FaFilePdf size={48} className="text-danger mb-3" color="red" />
                <h3 className="text-lg font-semibold text-gray-800">{doc.title}</h3>
                <p className="text-sm text-gray-500">{doc.description}</p>
                <div className="flex justify-center gap-3 mt-4">
                  {doc.fileUrl ? (
                    <>
                      <Button
                        variant="outline-primary"
                        onClick={() => handlePreview(doc.fileUrl)}
                      >
                        <FaEye className="me-2" color="green" /> Preview
                      </Button>
                      <Button
                        variant="outline-secondary"
                        onClick={() => handleDownload(doc.fileUrl)}
                      >
                        <FaDownload className="me-2" /> Download
                      </Button>
                    </>
                  ) : (
                    <span className="text-muted">No file uploaded</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>

      {/* Fullscreen Preview Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        dialogClassName="modal-90w"
        aria-labelledby="document-preview-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="document-preview-modal">Document Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          {previewUrl.endsWith(".pdf") ? (
            <iframe
              src={previewUrl}
              width="100%"
              height="100%"
              title="PDF Preview"
              style={{ border: "none" }}
            ></iframe>
          ) : (
            <p>Document preview is only available for PDFs.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
};

export default DownloadDocuments;
